import { useQueryWithEndpoint } from "@hydrologiq/shared/hooks/useGraphQLClient"
import { GetUnifiedHeadlinesDocument } from "@hydrologiq/gql-experience/graphql"

export interface UnifiedHeadlines {
  // Rental profile metrics
  assetsOnHire: number
  totalAlerts: number
  totalCo2eYesterday: number

  // Fuel producer profile metrics
  totalOrdered: number
  totalConsumed: number
  averageOrder: number
  returnedPerFulfillment: number
  returnedTrend: number

  // Run dry metrics (asset-level)
  earliestRunDryMinutes?: number
  earliestRunDrySite?: { id: string; name: string }
  earliestRunDryCustomer?: { id: string; name: string }

  // Installation-level run dry metrics (for fuel storage systems)
  earliestInstallationRunDryMinutes?: number
  earliestInstallationRunDrySite?: { id: string; name: string }
  earliestInstallationRunDrySystem?: { id: string; name: string }

  // Alert breakdown metrics
  alertsByStatus?: {
    new: number
    acknowledged: number
    attended: number
    completed: number
  }
  alertsBySeverity?: {
    critical: number
    warning: number
    info: number
  }
  highestAlertSeverity?: string
  topAlerts?: Array<{
    id: string
    name: string
    severity: string
    status: string
    message: string
    firedAt: string
  }>

  // Common
  computedAt: string
}

export interface UseUnifiedHeadlinesResult {
  data?: UnifiedHeadlines
  loading: boolean
  error?: Error
  refetch: () => void
}

export function useUnifiedHeadlines(): UseUnifiedHeadlinesResult {
  const { data, loading, error, refetch } = useQueryWithEndpoint(
    GetUnifiedHeadlinesDocument,
    {
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
    },
    "primary",
  )

  return {
    data: data?.unifiedHeadlines,
    loading,
    error: error as Error | undefined,
    refetch,
  }
}
